import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { HomeWork,PanoramaHorizontal,Payment, Event,ConfirmationNumber,Money,Inbox,Drafts,FilterNone,DateRange, LastPage, AllInclusive, Add, MoreVert, Schedule, Block, Subway, AirportShuttle, SupervisedUserCircle, Edit, Delete, SwapHoriz, Done, OpenInBrowser, CancelPresentation, AccountBalanceWallet } from '@material-ui/icons';

import TicketsIcon from "../../assets/img/tickets.png";
import MoneyIcon from "../../assets/img/money.png";
import InterchangeIcon from "../../assets/img/interchange.png";

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import {
    TableRow,
    TablePagination,
    TableFooter,
    TableContainer,
    TableCell,
    TableBody,
    Table,
    TableHead,
    Button,
    IconButton,
    Paper,
    Typography,
    Toolbar,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    AppBar,
    TextField,
    FormControlLabel,
    Checkbox,
    Container,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Menu,
    TextareaAutosize,
    Chip,
    LinearProgress,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Link,
    CircularProgress, ButtonGroup, Popover, ListItemIcon
} from "@material-ui/core";

import { DatePicker } from "@material-ui/pickers";


import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";


import { useSnackbar } from 'notistack';

import axios from 'axios';


import { TransportService, AdminService, FinanceService, ReportingService } from "./../../utils/web_config_2";

import { useHistory } from "react-router-dom";
import UserInfo from './login_info';

import Format from "date-fns/format";

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow: 1,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 250,
        }
    },
    btn: {
        textTransform: "capitalize",

    },
    formTitle: {
        flexGrow: 1,
    }
    , balance: {
        height: 180
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    paper: {
        padding: 15,
    },
}));

function TicketsAcGroup() {
    const classes = useStyles1();

    const history = useHistory();

    const [agentData, setAgentData] = useState({});
    const [agentProfile, setAgentProfile] = useState({});
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [transactionMessage, setTransactionMessage] = useState("Loading...");


    /// transaction table 




    const columns = [

        {
            name: "ticket_id",
            label: "Ticket ID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "ticket_reference",
            label: "Ticket Reference",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "amount",
            label: "Amount",
            options: {
                filter: true,
                sort: false,
                     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography>{formatMoney(value,0)} RWF</Typography>);
    }
            }
        },

        {
            name: "fee",
            label: "Inter Operability fee",
            options: {
                filter: true,
                sort: false,
                display: false
            }
        },

        {
            name: "tx_date",
            label: "Date",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "tx_time",
            label: "Time",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "wallet_id",
            label: "Card ID",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "plate_number",
            label: "Plate Number",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "route_name",
            label: "Route Name",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "organization_name",
            label: "Organization",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: false,
            }
        }
    ];

    function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            console.log(e)
        }
    };



    const [acData, setAcData] = useState({});

    useEffect(() => {
        var data = new AdminService().accountData;
        setAcData(data);
        axios.defaults.baseURL = new FinanceService().BASE_URL;
        // get_transaction(data.token);
        load_meta_data(data.token, "SAFARIBUS", from.value, to.value)
        get_revenue_tickets(data.token, "SAFARIBUS",from.value,to.value)
    }, []);

    // load meta data 
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalTickets, setTotalTickets] = useState(0);
    const load_meta_data = (token, provider, start, end)=>{
        const data = {
            "end_date": end,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": start
        };

        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_INETEROPERABILITY_META_REPORT, data)
            .then(res => {
                const data = res.data
                setTotalAmount(data.totalAmount);
                setTotalTickets(data.totalTaps);
            })
            .catch(err => {

            });
    }


    ///

    const onFromChange = (date) => {
        setFrom({ value: Format(date, ["yyyy-MM-dd",]), error: "" });
        setRange({ ...range, index: null });
        // get_revenue_tickets(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), to.value)
    };
    const onToChange = (date) => {
        setTo({ value: Format(date, ["yyyy-MM-dd",]) , error: "" });
        setRange({ ...range, index: null });
        // get_revenue_tickets(acData.token, "SAFARIBUS",from.value,Format(date, ["yyyy-MM-dd",]))
    };

    const [from, setFrom] = useState({
        value: Format(new Date(), ["yyyy-MM-dd",]),
        error: "",
    });
    const [to, setTo] = useState({
        value: Format(new Date(), ["yyyy-MM-dd",]),
        error: "",
    });
    const [range, setRange] = useState({ index: 0, acnhor: null });
    ///
    const [transactionLoad, setTransactionLoad] = useState(false);
    const [acRevenueTickets, setAcRevenueTickets] = useState({
        page: 0,
        count: 0,
        rowsPerPage: 10,
        filters: "",
        status: "Loading accounts....",
        loading: false,
        toggling: false,
        data: []
    });

    const get_revenue_tickets = (token, provider, start, end, page = 0, perPage = undefined) => {
        setTransactionLoad(true);
        const data = {
            "end_date": end,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": start
        };

        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_REVENUE_TICKETS + `?per_page=${perPage ?? acRevenueTickets.rowsPerPage}&page=${parseInt(page)===0?page+1:page}`, data)
            .then(res => {
                if (provider ==="SAFARIBUS"){
                    res.data.tickets.map((o)=>{
                        o['status']='Successful'
                    })
                    setAcRevenueTickets({ ...acRevenueTickets, data: res.data.tickets, count: res.data.total_items });
                }
                setTransactionLoad(false);
                    
            })
            .catch(err => {
                setTransactionLoad(false);
            });
    };

    const options = {
        filter: true,
        filterType: "dropdown",
        responsive: "stacked",
        selectableRows: false,
        elevation: 0,
        count: acRevenueTickets.count,
        page: acRevenueTickets.page,
        rowsPerPage: acRevenueTickets.rowsPerPage,
        serverSide: true,
        onCellClick: (cellData, cellMeta) => {
            var tr = acRevenueTickets.data[cellMeta.dataIndex];
            setDetails(tr)
            setDetailsOpen(true)
        },
        pagination: !transactionLoad,
        onChangePage: (page) => {
            setAcRevenueTickets({
                ...acRevenueTickets,
                page: page,
            });
            get_revenue_tickets(acData.token, "SAFARIBUS", from.value, to.value,page);
        },
        onChangeRowsPerPage: (rowsPerPage) => {
            setAcRevenueTickets({
                ...acRevenueTickets,
                rowsPerPage: rowsPerPage,
            });
            get_revenue_tickets(acData.token, "SAFARIBUS", from.value, to.value, acRevenueTickets.page, rowsPerPage);
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case "changePage":
                    break;
                default:
                    break;
            }
        },
    };

    const [details,setDetails]=useState({});


    /// ticket details
    const [detailsOpen, setDetailsOpen]=useState(false);

    /// ticket details


    const [downloadLoad, setDownloadLoad] = useState(false)
    const download_revenue_tickets = (token, provider, start, end) => {
        setDownloadLoad(true);
        const data = {
            "end_date": end,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": start
        };
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeadersFile(token));
        revenueOrganization.post(new ReportingService().DOWNLOAD_REVENUE_TICKETS, data)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/csv' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `tickets_${Format(new Date(), ["yyyy-MM-dd"])}.csv`;
                link.click();
                setDownloadLoad(false);
            })
            .catch(err => {
                setDownloadLoad(false);

            });
    };







    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={classes.root}>
                <Box display="flex">

                    <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>

                        <Box mr={1}> <FilterNone fontSize="large" color="primary" /></Box> <Typography variant="h5" color="default"><b>AC Mobility Tickets</b></Typography>

                    </Box>


                    <Box display="flex" mr={2} alignItems="center">
                        <Box mr={2}>
                            <ButtonGroup color="primary" disableElevation>
                                <Button
                                    className={classes.btn}
                                    variant={range.index == 0 ? "contained" : "outlined"}
                                    onClick={() => {
                                        setRange({ index: 0 });
                                        var date1 = Format(new Date(), ["yyyy-MM-dd",]);
                                        var date2 = Format(new Date(), ["yyyy-MM-dd",]);
                                        setFrom({ value: date1 });
                                        setTo({ value: date2 });
                                        load_meta_data(acData.token, "SAFARIBUS", date1, date2)
                                        get_revenue_tickets(acData.token, "SAFARIBUS", date1, date2)
                                    }}
                                >
                                    Today
                                </Button>
                                <Button
                                    className={classes.btn}
                                    variant={range.index == 1 ? "contained" : "outlined"}
                                    onClick={() => {
                                        setRange({ index: 1 });
                                        var date1 = new Date() ;
                                        date1.setDate(date1.getDate() - 7);
                                        var date2 = Format(new Date(), ["yyyy-MM-dd",]);
                                        // console.log(Format(date1, ["yyyy-MM-dd",]) );

                                        setFrom({ value: Format(date1, ["yyyy-MM-dd",]) });
                                        setTo({ value: date2 });
                                        load_meta_data(acData.token, "SAFARIBUS", Format(date1, ["yyyy-MM-dd",]), date2)
                                        get_revenue_tickets(acData.token, "SAFARIBUS", Format(date1, ["yyyy-MM-dd",]), date2)
                                    }}
                                >
                                    Last week
                                </Button>
                                <Button
                                    className={classes.btn}
                                    variant={range.index == 2 ? "contained" : "outlined"}
                                    onClick={() => {
                                        setRange({ index: 2 });
                                        var date1 =new Date();
                                        date1.setDate(date1.getDate() - 30);
                                        var date2 = Format(new Date(), ["yyyy-MM-dd",]);
                                        setFrom({ value: Format(date1, ["yyyy-MM-dd",]) });
                                        setTo({ value: date2 });
                                        get_revenue_tickets(acData.token, "SAFARIBUS", Format(date1, ["yyyy-MM-dd",]), date2)
                                        load_meta_data(acData.token, "SAFARIBUS", Format(date1, ["yyyy-MM-dd",]), date2)
                                        }}
                                >
                                    Last month
                                </Button>
                            </ButtonGroup>
                        </Box>

                        <IconButton
                            color="primary"
                            onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
                        >
                            <DateRange />
                        </IconButton>
                    </Box>



                </Box>

                <Box mt={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box width={1} display="flex" justifyContent="center">
                                    <Box flexGrow={1}>
                                        <Typography color="textSecondary">Total Taps</Typography>
                                        <Box mt={1} mb="4px" flexGrow={1}>
                                            <Typography variant="h6">{totalTickets}</Typography>
                                        </Box>

                                    </Box>
                                    <img src={TicketsIcon} height={50} />
                                    {/* <SwapHoriz color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box display="flex" width={1}>
                                    <Box flexGrow={1}>
                                        <Typography color="textSecondary">Total Amount</Typography>
                                        <Box mt={1} mb="4px">
                                            <Typography variant="h6">{formatMoney(totalAmount,0)} RWF</Typography>
                                        </Box>

                                    </Box>
                                    <img src={MoneyIcon} height={50} />
                                    {/* <AccountBalanceWallet color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box display="flex" width={1}>
                                    <Box flexGrow={1}>
                                        <Typography color="textSecondary">
                                            Interchange Fee
                                        </Typography>
                                        <Box mt={1} mb="4px">
                                            <Typography variant="h6">{formatMoney((totalAmount*1.5)/100,0)} RWF</Typography>
                                        </Box>
                                    </Box>
                                    <img src={InterchangeIcon} height={50} />
                                    {/* <AirportShuttle color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                <Box mt={2}>
                    {transactionLoad && <LinearProgress />}
                    <MUIDataTable
                        title={"Tickets"}
                        data={acRevenueTickets.data}
                        columns={columns}
                        options={options}
                    />
                </Box>

                <Popover
                    id={"pop-id"}
                    open={range.acnhor != null}
                    anchorEl={range.acnhor}
                    onClose={() => setRange({ ...range, acnhor: null })}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    elevation={4}
                >
                    <Box p={2}>
                        <Typography color="textSecondary">Select date range</Typography>
                        <Box mt={2} mb={2}>
                            <Box>
                                <DatePicker
                                    fullWidth
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="dense"
                                    maxDate={to.value}
                                    autoOk
                                    label={<Translate id="reports.forms.labels.from" />}
                                    value={from.value}
                                    inputVariant="outlined"
                                    onChange={onFromChange}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: { paddingRight: 0 },
                                    }}
                                />
                            </Box>
                            <Box>
                                <DatePicker
                                    fullWidth
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="dense"
                                    maxDate={new Date()}
                                    minDate={from.value}
                                    autoOk
                                    label={<Translate id="reports.forms.labels.to" />}
                                    value={to.value}
                                    inputVariant="outlined"
                                    onChange={onToChange}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: { paddingRight: 0 },
                                    }}
                                />
                            </Box>  
                            <Box display="flex" flexDirection="row" justifyContent="space-between">
                                <Button color="primary" disableElevation={false} variant='contained'
                                    disabled={transactionLoad}
                                    onClick={(e) => {
                                        get_revenue_tickets(acData.token, "SAFARIBUS", from.value, to.value)
                                        load_meta_data(acData.token, "SAFARIBUS", from.value, to.value)
                                    }}
                                >{transactionLoad ? (<CircularProgress size={25} />) : ("Filter")}</Button>

                                <Button color="secondary" size='small' disableElevation={false} variant='contained'
                                    disabled={downloadLoad}
                                    onClick={(e) => {
                                        download_revenue_tickets(acData.token, "SAFARIBUS", from.value, to.value)
                                    }}
                                >{downloadLoad ? (<CircularProgress size={25} />) : ("Download")}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Popover>

                <Dialog
                    maxWidth="sm"
                    fullWidth
                    open={detailsOpen}
                    onClose={() => setDetailsOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Ticket Details"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                           <Box>
                                <List component="nav" aria-label="main mailbox folders">
                                    <ListItem >
                                        <ListItemIcon>
                                            <Inbox />
                                        </ListItemIcon>
                                        <ListItemText primary="Ticket ID" secondary={details.ticket_id} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <ConfirmationNumber />
                                        </ListItemIcon>
                                        <ListItemText primary="Ticket Reference" secondary={details.ticket_reference} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <Money />
                                        </ListItemIcon>
                                        <ListItemText primary="Amount" secondary={details.amount + " RWF"} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <Money />
                                        </ListItemIcon>
                                        <ListItemText primary="Interoperability Fee" secondary={(details.amount*1.5)/100 +" RWF"} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <Event />
                                        </ListItemIcon>
                                        <ListItemText primary="Date" secondary={details.tx_date} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <Schedule />
                                        </ListItemIcon>
                                        <ListItemText primary="Time" secondary={details.tx_time} />
                                    </ListItem>


                                    <ListItem >
                                        <ListItemIcon>
                                            <Payment />
                                        </ListItemIcon>
                                        <ListItemText primary="Card ID" secondary={details.wallet_id} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <AirportShuttle />
                                        </ListItemIcon>
                                        <ListItemText primary="Plate Number" secondary={details.plate_number} />
                                    </ListItem>


                                    <ListItem >
                                        <ListItemIcon>
                                            <PanoramaHorizontal />
                                        </ListItemIcon>
                                        <ListItemText primary="Route Name" secondary={details.route_name} />
                                    </ListItem>

                                    <ListItem >
                                        <ListItemIcon>
                                            <HomeWork />
                                        </ListItemIcon>
                                        <ListItemText primary="Organization Name" secondary={details.organization_name} />
                                    </ListItem>
                                    
                                </List>
                           </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDetailsOpen(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>


            </div></MuiPickersUtilsProvider>
    );
}
export default withLocalize(TicketsAcGroup);